import {
  Area,
  AreaChart,
  CartesianGrid,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { HeatPoint } from "@/mocks/events";

export default function HeatChart({ data }: { data: HeatPoint[] }) {
  const peak = data.reduce((max, point) => (point.value > max.value ? point : max), data[0]);

  return (
    <div className="h-[280px] md:h-[340px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 12, right: 12, left: -16, bottom: 0 }}>
          <defs>
            <linearGradient id="detailHeatFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="oklch(var(--primary-500))" stopOpacity={0.45} />
              <stop offset="100%" stopColor="oklch(var(--primary-500))" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-300))" vertical={false} />
          <XAxis
            dataKey="time"
            tick={{ fontSize: 11, fill: "oklch(var(--foreground-500))" }}
            axisLine={{ stroke: "oklch(var(--background-300))" }}
            tickLine={false}
            interval="preserveStartEnd"
          />
          <YAxis
            tick={{ fontSize: 11, fill: "oklch(var(--foreground-500))" }}
            axisLine={false}
            tickLine={false}
          />
          {peak && (
            <ReferenceLine
              x={peak.time}
              stroke="oklch(var(--accent-500))"
              strokeDasharray="4 4"
              label={{
                value: "峰值",
                position: "top",
                fontSize: 11,
                fill: "oklch(var(--accent-700))",
              }}
            />
          )}
          <Tooltip
            contentStyle={{
              background: "oklch(var(--background-50))",
              border: "1px solid oklch(var(--background-300))",
              borderRadius: 8,
              fontSize: 12,
              color: "oklch(var(--foreground-900))",
            }}
            labelStyle={{ color: "oklch(var(--foreground-600))" }}
            formatter={(value: any) => [`相对热度 ${value}`, ""]}
          />
          <Area
            type="monotone"
            dataKey="value"
            stroke="oklch(var(--primary-500))"
            strokeWidth={2.5}
            fill="url(#detailHeatFill)"
            dot={{ r: 3, fill: "oklch(var(--primary-500))", strokeWidth: 0 }}
            activeDot={{ r: 5 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}